import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于天狼影院',
    description: '天狼影院 - 高清免费在线观看平台，了解我们的品牌故事、核心优势与联系方式',
    url: 'https://www.tianlangcinema.com/about',
    about: {
      '@type': 'Organization',
      name: '天狼影院',
      url: 'https://www.tianlangcinema.com',
      description: '天狼影院提供高清免费在线观看，即点即播不缓冲，流畅追剧看电影',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6666',
        contactType: 'customer service',
        email: 'contact@tianlangcinema.com',
      },
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div
            className="relative w-full h-[280px] md:h-[360px] bg-cover bg-center"
            style={{
              backgroundImage:
                'url(https://readdy.ai/api/search-image?query=Modern%20cinema%20interior%20with%20warm%20golden%20lighting%2C%20empty%20luxury%20theater%20seats%20with%20red%20velvet%2C%20large%20screen%20displaying%20soft%20glow%2C%20elegant%20atmosphere%2C%20architectural%20photography%2C%20warm%20ambient%20light%2C%20cinematic%20widescreen%20composition&width=1920&height=800&seq=about-banner-001&orientation=landscape)',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center px-4">
                <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-3">
                  关于天狼影院
                </h1>
                <p className="text-sm md:text-base text-foreground-300 max-w-lg mx-auto">
                  高清免费在线观看，即点即播不缓冲，让每个人都能畅享极致观影体验
                </p>
              </div>
            </div>
          </div>

          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

            <section className="py-10 md:py-14">
              <div className="max-w-4xl mx-auto">
                <div className="text-center mb-10">
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                    品牌介绍
                  </h2>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    天狼影院成立于2020年，是国内领先的在线视频播放平台之一。我们秉承"让观影更简单"的理念，
                    致力于为广大用户提供高清流畅的在线观影体验。经过多年发展，天狼影院已积累了海量的视频资源库，
                    涵盖电影、电视剧、综艺、动漫、纪录片等多个品类，日均服务数百万用户。
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
                  <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-4">
                      <i className="ri-eye-line text-xl"></i>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                      我们的愿景
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      成为全球用户首选的在线视频平台，让优质内容触手可及。我们相信，每个人都应该能够方便地欣赏到高品质的影视作品，
                      不受地域、设备和时间的限制。
                    </p>
                  </div>
                  <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-500 mb-4">
                      <i className="ri-flag-line text-xl"></i>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                      我们的使命
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      通过技术创新持续优化播放体验，实现即点即播零等待。同时不断扩充内容库，
                      引进国内外优质影视资源，满足不同用户的多元化观影需求。
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="py-10 md:py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
              <div className="max-w-4xl mx-auto">
                <div className="text-center mb-10">
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                    品牌声誉
                  </h2>
                  <p className="text-sm text-foreground-600">用户与行业的双重认可</p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-10">
                  {[
                    { number: '5000万+', label: '累计用户' },
                    { number: '10万+', label: '视频资源' },
                    { number: '99.7%', label: '播放成功率' },
                    { number: '4.8', label: '用户评分' },
                  ].map((stat, index) => (
                    <div
                      key={index}
                      className="text-center p-5 rounded-xl bg-background-50 border border-background-200"
                    >
                      <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500 mb-1">
                        {stat.number}
                      </div>
                      <p className="text-sm text-foreground-600">{stat.label}</p>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col gap-4">
                  {[
                    {
                      name: '张先生',
                      role: '资深影评人',
                      content: '天狼影院的画质和流畅度令人印象深刻，资源更新速度也很快，是我日常追剧的首选平台。',
                    },
                    {
                      name: '李女士',
                      role: '影视爱好者',
                      content: '分类很全面，从国产大片到小众纪录片都能找到。界面设计也很简洁美观，使用体验非常好。',
                    },
                    {
                      name: '王同学',
                      role: '大学生',
                      content: '不用注册就能看，非常方便！而且手机和电脑都能流畅播放，画质清晰不卡顿，强烈推荐。',
                    },
                  ].map((testimonial, index) => (
                    <div
                      key={index}
                      className="p-5 rounded-xl bg-background-50 border border-background-200"
                    >
                      <div className="flex items-center gap-2 mb-3">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <div key={star} className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-star-fill text-accent-500 text-xs"></i>
                          </div>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                        {testimonial.content}
                      </p>
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                          <span className="text-xs font-medium text-primary-500">
                            {testimonial.name.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-900">
                            {testimonial.name}
                          </p>
                          <p className="text-xs text-foreground-500">{testimonial.role}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="py-10 md:py-14">
              <div className="max-w-4xl mx-auto">
                <div className="text-center mb-10">
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-600">
                    如有任何问题或建议，欢迎通过以下方式与我们联系
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
                  <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10 text-primary-500">
                      <i className="ri-mail-line text-xl"></i>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">
                      电子邮箱
                    </h3>
                    <p className="text-sm text-foreground-600">contact@tianlangcinema.com</p>
                  </div>
                  <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10 text-primary-500">
                      <i className="ri-phone-line text-xl"></i>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">
                      客服热线
                    </h3>
                    <p className="text-sm text-foreground-600">400-888-6666</p>
                  </div>
                  <div className="text-center p-6 rounded-xl bg-background-100 border border-background-200">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10 text-primary-500">
                      <i className="ri-map-pin-line text-xl"></i>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-950 mb-1">
                      公司地址
                    </h3>
                    <p className="text-sm text-foreground-600">北京市朝阳区望京科技园A座</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}